// extracted by mini-css-extract-plugin
export default {"issueTaskItem":"IssueTaskCard_issueTaskItem__gC1gx","inputNumberRight":"IssueTaskCard_inputNumberRight__gPaWv"};